import React from 'react';
import { components, SingleValueProps } from 'react-select';
import BaseSelectWithIcon from 'lib/BaseSelect/BaseSelectWithIcon';
import { mediaTypeDataOptions } from 'consts/mediaTypeDataOptions';
import { DirectSalesMediaTypeLabel, DirectSalesMediaType } from 'components/common/types/DirectSalesCampaign.types';
import mediaSvg from 'assets/icons/images-square.svg';

interface FilterMediaTypeProps {
  selectedMediaType?: DirectSalesMediaType;
  changeFilters: (filters: { mediaType: DirectSalesMediaType }) => void;
  isDisabled?: boolean;
}

const CustomSingleValue = ({
  clearValue,
  cx,
  getStyles,
  getValue,
  hasValue,
  isMulti,
  isRtl,
  options,
  selectOption,
  selectProps,
  setValue,
  theme,
  data,
  innerProps,
  isDisabled: singleValueDisabled,
  children,
}: SingleValueProps): React.ReactElement => {
  return (
    <components.SingleValue
      clearValue={clearValue}
      cx={cx}
      getStyles={getStyles}
      getValue={getValue}
      hasValue={hasValue}
      isMulti={isMulti}
      isRtl={isRtl}
      options={options}
      selectOption={selectOption}
      selectProps={selectProps}
      setValue={setValue}
      theme={theme}
      data={data}
      innerProps={innerProps}
      isDisabled={singleValueDisabled}
    >
      <div className="truncate max-w-full">{children}</div>
    </components.SingleValue>
  );
};

const FilterMediaType: React.FC<FilterMediaTypeProps> = ({ selectedMediaType, changeFilters, isDisabled = false }) => {
  return (
    <div className="w-48">
      <BaseSelectWithIcon
        dataTestId="mediaType-select"
        name="mediaType"
        classNameWrapper="w-full"
        icon={mediaSvg}
        selectedValue={
          selectedMediaType
            ? {
                code: selectedMediaType,
                name: DirectSalesMediaTypeLabel[selectedMediaType],
              }
            : null
        }
        onSelect={(_, mediaType) => {
          const code = Array.isArray(mediaType) ? mediaType[0]?.code : mediaType?.code;
          changeFilters({ mediaType: code as DirectSalesMediaType });
        }}
        placeholder="Select media type"
        options={mediaTypeDataOptions}
        optionControl="radio"
        isDisabled={isDisabled}
        customComponents={{
          SingleValue: CustomSingleValue,
        }}
      />
    </div>
  );
};

export default FilterMediaType;
